import TrackedBill from './TrackedBill'
import LuTrackedBillPermission from './LuTrackedBillPermission'
import User from './User'
export default class TrackedBillUser {
  constructor(objIn = {}) {
    const defaults = {
      //ID is required
      ID: 0,
      //TrackedBillID is required
      TrackedBillID: 0,
      //UserID is required
      UserID: 0,
      //TrackedBillPermissionID is required
      TrackedBillPermissionID: 0,
    }
    let obj = {}
    Object.assign(obj, defaults, objIn)
    this.ID = obj.ID
    this.TrackedBillID = obj.TrackedBillID
    this.UserID = obj.UserID
    this.TrackedBillPermissionID = obj.TrackedBillPermissionID
    this.TrackedBill = new TrackedBill(obj.TrackedBill || {})
    this.TrackedBillPermission = new LuTrackedBillPermission(obj.TrackedBillPermission || {})
    this.User = new User(obj.User || {})
  }
  removeRelated() {
    let obj = Object.assign({}, this)
    obj.TrackedBill = null
    obj.TrackedBillPermission = null
    obj.User = null
    return obj
  }
  root() {
    let obj = Object.assign({}, this)
    obj.TrackedBill = null
    obj.TrackedBillPermission = null
    obj.User = null
    return obj
  }
}
